export const PROGRAM_OPERATION_PLAN_TITLE_SUFFIX = ' - 프로그램 운영 계획';

export type ProgramExportTrackTimetableParts = {
  trackLabel: string;
  timetableLabel: string;
};

export function buildProgramExportTrackTimetableParts(params: {
  trackName: string;
  timetableName?: string;
}): ProgramExportTrackTimetableParts {
  return {
    trackLabel: (params.trackName ?? '').trim(),
    timetableLabel: (params.timetableName ?? '').trim(),
  };
}

export function formatProgramExportTrackTimetableFlat(
  parts: ProgramExportTrackTimetableParts,
  suffix = PROGRAM_OPERATION_PLAN_TITLE_SUFFIX
): string {
  const track = parts.trackLabel.trim();
  const timetable = parts.timetableLabel.trim();

  if (track && timetable && track !== timetable) {
    return `${track}\n(${timetable})${suffix}`;
  }
  if (track) {
    return `${track}${suffix}`;
  }
  if (timetable) {
    return `(${timetable})${suffix}`;
  }
  return `편제${suffix}`;
}

export function buildProgramTrackDocumentTitle(params: {
  trackName: string;
  timetableName?: string;
}): string {
  return formatProgramExportTrackTimetableFlat(buildProgramExportTrackTimetableParts(params));
}

export function buildProgramNamedDocumentTitle(name: string): string {
  const label = (name || '프로그램').trim() || '프로그램';
  return `${label}${PROGRAM_OPERATION_PLAN_TITLE_SUFFIX}`;
}

export function resolveProgramExportTemplateLabelParts(
  trackLabel: string,
  timetableLabel: string
): ProgramExportTrackTimetableParts & { flatLabel: string } {
  const track = trackLabel.trim();
  const timetable = timetableLabel.trim();

  if (track && timetable && track !== timetable) {
    return {
      trackLabel: track,
      timetableLabel: timetable,
      flatLabel: `${track}\n(${timetable})`,
    };
  }
  if (track) {
    return { trackLabel: track, timetableLabel: '', flatLabel: track };
  }
  if (timetable) {
    return { trackLabel: '', timetableLabel: timetable, flatLabel: `(${timetable})` };
  }
  return { trackLabel: '', timetableLabel: '', flatLabel: '' };
}

export function resolveProgramExportTimetableName(
  explicitTimetableName: string | undefined,
  tableRows: ReadonlyArray<{ timetableText?: string; annualCellKey?: string }>,
  programCellsByAnnualKey?: Readonly<Record<string, { timetable_text?: string | null }>>
): string {
  const explicit = (explicitTimetableName ?? '').trim();
  if (explicit) return explicit;
  for (const row of tableRows) {
    const fromRow = (row.timetableText ?? '').trim();
    if (fromRow) return fromRow;
    const annualCellKey = row.annualCellKey?.trim();
    if (annualCellKey && programCellsByAnnualKey) {
      const fromCell = String(programCellsByAnnualKey[annualCellKey]?.timetable_text ?? '').trim();
      if (fromCell) return fromCell;
    }
  }
  return '';
}
